<template>
    <div class="sidenav"  id="mySidenav" style="z-index:2000;" >
        <div class="modal-header " style="height:61px;background-color: #ffad69;">    
            <h4 class="modal-title"><i class="fal fa-search"></i> Seleziona assegnatario 
            <button onclick="utils.closeNav()" type="button" class="close float-right" ><span aria-hidden="true">&times;</span></button></h4>
        </div>
        <div class="modal-body" >
            <div v-show="tipoVisualizzazioneNav == 1">
                <form  autocomplete="off">            
                    <div class="row">
                        <div class="form-group col-md-6" style="margin-bottom:.4rem">
                            <label style="margin-bottom: 0.0rem;">Cognome</label>
                            <input type="text" class="form-control" v-model="searchPersoneFisiche.COGNOME.VALUE">
                        </div> 
                        <div class="form-group col-md-6" style="margin-bottom:.4rem">
                            <label style="margin-bottom: 0.0rem;">Nome</label>
                            <input type="text" class="form-control" v-model="searchPersoneFisiche.NOME.VALUE">
                        </div> 
                    </div>
                </form>
                <ul class="list-group mt-4">
                    <li v-for="persona in paginatedListSelezionabili.arr" v-on:click="addAssegnatario(persona)" v-bind:key="persona" class="list-group-item">
                        {{ persona.COGNOME }} {{ persona.NOME }}
                    </li>
                </ul>                 
            </div>               
        </div>
    </div>
    <div class="form-group row">
    <!-- <div class="row" style="width:100%"> -->
        <div class="form-group col-md-3">
            <label >ID APPEZZAMENTO</label>
            <input autocomplete="off" type="text"  class="form-control form-control-sm" placeholder="es. Q111" v-model="terreno.ID_APPEZZAMENTO">
        </div> 
        <div class="form-group col-md-3">
            <label>Foglio</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="FOGLIO" v-model="terreno.FOGLIO">
        </div>
        <div class="form-group col-md-3">
            <label>Particella</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="PARTICELLA" v-model="terreno.PARTICELLA">
        </div>
        <div class="form-group col-md-3">
            <label>Particella catasto</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="PARTICELLA CATASTO" v-model="terreno.PAR_CATASTO">
        </div>
        <div class="form-group col-md-6">
            <label>Località</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="es. POLLEDRARA-XXX-MONTE ROMANO" v-model="terreno.LOCALITA">
        </div>
        <div class="form-group col-md-4">
            <label>Tipologia Quota / Terreno</label>
            <select class="form-control form-control-sm" v-model="terreno.FK_ID_TIPO" @change="onTipoTerrenoChange()">
                <option v-for="tipo in tipiTerreno" :key="tipo.ID_TIPO" :value="tipo.ID_TIPO">
                    {{ tipo.DESCRIZIONE }} (€ {{ parseFloat(tipo.TARIFFA || 0).toFixed(2) }} - {{ tipo.MODO == 'F' ? 'Fisso' : 'Prop.' }})
                </option>
            </select>
        </div>
        <div class="form-group col-md-2">
            <label>Superficie</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="SUPERFICIE" v-model="terreno.SUPERFICIE" @input="calcolaCanoneTotale()">
        </div>
        <div class="form-group col-md-3">
            <label>Reddito domestico</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="REDDITO DOMESTICO" v-model="terreno.REDD_DOM">
        </div>
        <div class="form-group col-md-3">
            <label>Reddito agrario</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="REDDITO AGRARIO" v-model="terreno.REDD_AGR">
        </div>
        <div class="form-group col-md-2">
            <label>Canone unit. (€)</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="CANONE UNITARIO" v-model="terreno.CANONE_UNIT" @input="calcolaCanoneTotale()">
        </div>
        <div class="form-group col-md-2">
            <div class="d-flex justify-content-between align-items-center">
                <label class="mb-0">Canone tot. (€)</label>
                <button type="button" class="btn btn-link btn-sm p-0 text-primary" style="font-size:11px;" title="Ricalcola canone in base a tipologia e superficie" v-on:click="calcolaCanoneTotale()">
                    <i class="fal fa-sync"></i>
                </button>
            </div>
            <input autocomplete="off" type="text" class="form-control form-control-sm mt-1" placeholder="CANONE TOTALE" v-model="terreno.CANONE_TOT">
        </div>    
        <div class="form-group col-md-2">
            <label>Addizionale (€)</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="ADDIZIONALE" v-model="terreno.ADDIZIONALE">
        </div>
    </div>
    <div class="row mb-2">
        <div class="col-12">
            <button class="btn btn-primary mr-2" v-if="!terreno.isAssegnato" v-on:click="openModificaAssegnazione(undefined)"><i class="fal fa-user-plus mr-1"></i> Assegna terreno</button>
            <button class="btn btn-outline-info mr-2" v-if="terreno.isAssegnato" v-on:click="stampaCertificatoPossesso(terreno.ID_TERRENO)"><i class="fal fa-file-certificate mr-1"></i> Stampa Certificato</button>
            <button class="btn btn-outline-success mr-2" v-if="terreno.isAssegnato" v-on:click="stampaAvvisoPagamento(terreno.ID_TERRENO)"><i class="fal fa-file-invoice-dollar mr-1"></i> Avviso di Pagamento</button>
        </div>
    </div>

    <div class="isprint-grid-container"  >    
        <table class="isprint-grid shadow" >
            <thead class="isprint-grid-thead" >
                <tr style="left: 0px;background: #0597f2;color:#fff">
                    <th  style="width:30%"><span >Assegnatario</span></th>
                    <th  style="width:18%"><span >Data assegnazione</span></th>
                    <th  style="width:18%"><span >Data revisione</span></th>
                    <th  style="width:9%"><span >In corso</span></th>
                    <th  style="width:25%"><span >Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr :class= "{ 'bg-success': assegnazione.VALIDO, 'bg-danger': !assegnazione.VALIDO, 'bg-warning': assegnazione.DATA_REVISIONE<dataOdierna(), 'text-light': 1 } " style="left: 0px;height:50px" v-bind:key="assegnazione.ID_ASSEGNAZIONE"  v-for="assegnazione in terreno.assegnazioni">                        
                    <td  style="width:30%">
                        <div class="float-left pt-2" style="width:10%">
                            <i class="fal mr-1 fa-2x" v-bind:class="{'fa-user':assegnazione.FK_ID_PERSONA_FISICA > 0,'fa-university':assegnazione.FK_ID_PERSONA_GIURIDICA > 0}"></i>
                        </div>
                        <div class="float-left pt-1" style="width: 90%">
                            <strong>
                                {{ assegnazione.COGNOME}} {{ assegnazione.NOME}}
                            </strong>
                            <br/>
                            <small>{{ filters.formatDate(assegnazione.DATA_NASCITA)}} - {{ assegnazione.CODICE_FISCALE}}</small>
                        </div>
                    </td>
                    <td  style="width:18%">
                        {{filters.formatDate(assegnazione.DATA_ASSEGNAZIONE)}}
                    </td>
                    <td  style="width:18%">
                        {{filters.formatDate(assegnazione.DATA_REVISIONE)}}
                    </td>
                    <td  style="width:9%">
                        <small v-if="assegnazione.VALIDO">SI</small>
                        <small v-if="!assegnazione.VALIDO">NO</small>
                    </td>
                    <td  style="width:25%">
                        <button title="Stampa Certificato" class="btn btn-grid btn-info mr-1" v-on:click="stampaCertificatoPossesso(terreno.ID_TERRENO, assegnazione.FK_ID_PERSONA_FISICA)"><i class="fal fa-file-certificate"></i></button>
                        <button title="Avviso di Pagamento" class="btn btn-grid btn-success mr-1" v-on:click="stampaAvvisoPagamento(terreno.ID_TERRENO, assegnazione.FK_ID_PERSONA_FISICA)"><i class="fal fa-file-invoice-dollar"></i></button>
                        <button title="Modifica" class="btn btn-grid btn-warning mr-1" v-on:click="openModificaAssegnazione(assegnazione)"><i class="fal fa-pencil"></i></button>
                        <button v-if="assegnazione.VALIDO" title="Elimina" class="btn btn-grid btn-danger" v-on:click="eliminaAssegnazione(assegnazione)"><i class="fas fa-trash-alt"></i></button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="modal fade" id="popUpAssegnazione" data-backdrop="false" role="dialog"  aria-modal="true" >
        <div class="modal-dialog" style="min-width:800px;"  >
            <div class="modal-content" >
                <div class="modal-header modal-header" style="background-color: #226636;">
                    <h4 style="color:#fff" class="modal-title">Modifica/aggiungi assegnazione</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" >
                    Assegnatario
                    <div class="row">
                        <div class="col-12">
                            <ul class="list-group">
                                <li class="list-group-item">
                                    <div class="float-left pt-2" style="width:50px">
                                        <i class="fal mr-1 fa-2x" v-bind:class="{'fa-user':assegnazioneSelezionata.FK_ID_PERSONA_FISICA > 0,'fa-university':assegnazioneSelezionata.FK_ID_PERSONA_GIURIDICA > 0}"></i>
                                    </div>
                                    <div class="float-left pt-1" style="width: 600px">
                                        <strong>
                                            {{ personaSelezionata.COGNOME}} {{ personaSelezionata.NOME}}
                                        </strong>
                                        <br/>
                                        <small>{{ filters.formatDate(personaSelezionata.DATA_NASCITA)}} - {{ personaSelezionata.CODICE_FISCALE}}</small>
                                    </div>
                                    <div class="float-rigt">
                                        <button class="btn btn-warning float-right btn-sm" v-on:click="openRicercaAssegnatari();"><i class="fal fa-pencil"></i></button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="form-group col-md-5">
                            <label >Data assegnazione</label>
                            <DatePicker v-model="assegnazioneSelezionata.DATA_ASSEGNAZIONE" :dim="'sm'"></DatePicker>
                        </div> 
                        <div class="form-group col-md-5">
                            <label>Data revisione/cessazione</label>
                            <DatePicker v-model="assegnazioneSelezionata.DATA_REVISIONE" :dim="'sm'"></DatePicker>
                        </div> 
                        <div class="form-group col-md-2">
                            <label>In corso</label>
                            <select class="form-control form-control-sm" v-model="assegnazioneSelezionata.VALIDO">
                                <option value="1">SI</option>
                                <option value="0">NO</option>
                            </select>
                        </div> 
                        
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaAssegnazione()"><i class="fa fa-check"></i> Salva</button>
                </div>
            </div>  
        </div>
    </div>
</template>
<script>

import { computed } from 'vue'
import DatePicker from '@/components/utils/DatePicker.vue'




export default {
    name: 'Terreno',
    components:{
        DatePicker
    },
    props: {
        modelValue: {
            type: Object,
            default: () => ({}),
        },
        co:{
            type:Array,
        },
    },
    emits: ['update:modelValue',"ricarica","getTerreno"],
    setup(props, { emit }) {
        const terreno = computed({
            get: () => props.modelValue,
            set: (val) => emit('update:modelValue', val),
        });
        return { 
            terreno,
         };
    },
    data:function(){
        return{
            filters:global.filters,
            assegnazioneSelezionata: {},
            personaSelezionata: {},
            tipoVisualizzazioneNav:0,
            searchPersoneFisiche:  {
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:5000},
                COGNOME:{TYPE:'TEXT',VALUE:''},
                NOME:{TYPE:'TEXT',VALUE:''},            
            },
            personeFisiche: Array(),
            tipiTerreno: Array(),
        }
    },
    methods: {
        dataOdierna: function() {
            var d = new Date(),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;

            return [year, month, day].join('-');
        },
        stampaCertificatoPossesso : function(idTerreno, idPersonaFisica){
            var url = global.utils.BASE_API + "core/report?ID_REPORT=1003&ID_TERRENO=" + idTerreno;
            if (idPersonaFisica) {
                url += "&ID_PERSONA_FISICA=" + idPersonaFisica;
            }
            url += "&SESSION_TOKEN=" + utils.SESSION_TOKEN;
            window.open(url);
        },
        stampaAvvisoPagamento : function(idTerreno, idPersonaFisica){
            var url = global.utils.BASE_API + "core/report?ID_REPORT=1004&ID_TERRENO=" + idTerreno;
            if (idPersonaFisica) {
                url += "&ID_PERSONA_FISICA=" + idPersonaFisica;
            }
            url += "&SESSION_TOKEN=" + utils.SESSION_TOKEN;
            window.open(url);
        },
        getAssegnazione: function(assegnazione){            
            global.utils.get('emmet/assegnazione',{ID_ASSEGNAZIONE: assegnazione.ID_ASSEGNAZIONE},(response)=>{
                this.assegnazioneSelezionata = utils.clone(response.data); 
            });
            global.utils.get('emmet/persona_fisica',{ID_PERSONA_FISICA: assegnazione.FK_ID_PERSONA_FISICA},(response)=>{
                console.log(response.data);
                this.personaSelezionata = utils.clone(response.data); 
            }) 
        },
        openModificaAssegnazione: function(assegnazione){
            if (assegnazione != undefined){
                this.assegnazioneSelezionata = utils.clone(assegnazione);
                this.getAssegnazione(assegnazione);
            }else{
                this.assegnazioneSelezionata.ID_ASSEGNAZIONE = 0;
                this.assegnazioneSelezionata.DATA_ASSEGNAZIONE = "";
                this.assegnazioneSelezionata.DATA_REVISIONE = "";
                this.assegnazioneSelezionata.FK_ID_TERRENO = this.terreno.ID_TERRENO;
                this.assegnazioneSelezionata.VALIDO = 1;
                this.personaSelezionata.COGNOME = "";
                this.personaSelezionata.NOME = "";
                this.personaSelezionata.DATA_NASCITA = "";
                this.personaSelezionata.CODICE_FISCALE = "";
            }
            
            var modal = utils.openModal('popUpAssegnazione');
        },
        openRicercaAssegnatari : function(){
            this.tipoVisualizzazioneNav = 1;
            global.utils.openNav();
            global.utils.get('/emmet/persone_fisiche',{},(response)=>{
                this.personeFisiche = response.data;
            });
        },
        addAssegnatario : function(persona) {
            this.assegnazioneSelezionata.FK_ID_PERSONA_FISICA= persona.ID_PERSONA_FISICA;
            utils.closeNav();

            global.utils.get('emmet/persona_fisica',{ID_PERSONA_FISICA: this.assegnazioneSelezionata.FK_ID_PERSONA_FISICA},(response)=>{
                this.personaSelezionata = utils.clone(response.data); 
            })
        },
        salvaAssegnazione : function(){
            //update
            if(this.assegnazioneSelezionata.ID_ASSEGNAZIONE> 0){
                global.utils.put('/emmet/assegnazione',this.assegnazioneSelezionata, (response) => {
                    if (response.esito == 0){
                        var modal = utils.closeModal('popUpAssegnazione');
                        this.$emit('getTerreno',this.terreno.ID_TERRENO);
                        utils.alert.success(response.messaggio);
                    }
                });
                this.tipoVisualizzazioneNav = 0;
            }else{
            //insert
                this.assegnazioneSelezionata.cod_utente = this.personaSelezionata.ABBREVIAZIONE;
                global.utils.post('/emmet/assegnazione',this.assegnazioneSelezionata,(response)=>{
                    if (response.esito == 0){
                        this.$emit('getTerreno',this.terreno.ID_TERRENO);
                        var modal = utils.closeModal('popUpAssegnazione')
                        utils.alert.success(response.messaggio);
                    }
                });
            }
            utils.closeNav();
        },
        eliminaAssegnazione : function(assegnazione){
            utils.alert.confirm("Sei sicuro di voler eliminare l'assegnazione",()=>{
                global.utils.delete('/emmet/assegnazione',assegnazione,(response)=>{
                    if (response.esito == 0){
                        this.$emit('getTerreno',this.terreno.ID_TERRENO);
                        utils.alert.success(response.messaggio);
                    }
                });
            },this.$root);
        },
        
        getTipiTerreno : function(){
            global.utils.get('/emmet/tipi_terreno',{}, (response) => {       
                this.tipiTerreno = response.data || [];
            });
        },
        onTipoTerrenoChange : function(){
            if (!this.terreno.FK_ID_TIPO) return;
            var tipo = this.tipiTerreno.find(t => t.ID_TIPO == this.terreno.FK_ID_TIPO);
            if (tipo && tipo.TARIFFA !== undefined && tipo.TARIFFA !== null && tipo.TARIFFA !== ''){
                var tariffaNum = parseFloat(tipo.TARIFFA);
                // Se canone unitario non è valorizzato o è 0 o stiamo creando un nuovo terreno
                if (!this.terreno.CANONE_UNIT || parseFloat(this.terreno.CANONE_UNIT) === 0 || !this.terreno.ID_TERRENO || this.terreno.ID_TERRENO === 0){
                    this.terreno.CANONE_UNIT = tariffaNum.toFixed(2);
                }
                this.calcolaCanoneTotale();
            }
        },
        calcolaCanoneTotale : function(){
            var tipo = this.tipiTerreno.find(t => t.ID_TIPO == this.terreno.FK_ID_TIPO);
            var modo = tipo ? tipo.MODO : 'F';
            var unit = parseFloat(this.terreno.CANONE_UNIT || 0);
            var sup = parseFloat(this.terreno.SUPERFICIE || 0);

            if (modo === 'F'){
                if (unit > 0){
                    this.terreno.CANONE_TOT = unit.toFixed(2);
                }
            } else {
                if (unit > 0 && sup > 0){
                    this.terreno.CANONE_TOT = (unit * sup).toFixed(2);
                }
            }
        },
    },
    computed: {
        paginatedListSelezionabili(){
            var arr = utils.inGrid(this.personeFisiche,this.searchPersoneFisiche);
            return arr;
        },
        
    },
    watch: {
        
    },
    created : function(){
        this.getTipiTerreno();
    },
}

</script>